import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import jwt from "../plugins/jwt";
import instance from "../plugins/axios";

export default createStore({
  state: {
    token: {
      accessToken: jwt.getToken(),
    },
    isAuthenticated: !!jwt.getToken(),
  },
  getters: {
    getAccessToken: function (state) {
      return state.token.accessToken;
    },
    isAuthenticated: function (state) {
      return state.isAuthenticated;
    },
  },
  mutations: {
    logout: function (state = {}) {
      state.token.accessToken = "";
      state.isAuthenticated = false;
      jwt.destroyToken();
    },
    login: function (state, payload = {}) {
      state.token.accessToken = payload.accessToken;
      state.isAuthenticated = true;
      jwt.saveToken(payload.accessToken);
    },
  },
  actions: {
    logout: function (context) {
      return new Promise((resolve) => {
        context.commit("logout");
        resolve();
      });
    },
    login: function (context, payload) {
      const params = {
        username: payload.username,
        password: payload.password,
      };
      return new Promise((resolve, reject) => {
        instance
          .post("/auth/login", params)
          .then((response) => {
            const { data } = response;
            if (data.accessToken) {
              context.commit("login", {
                accessToken: data.accessToken,
              });
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  plugins: [createPersistedState()],
});
